import { Button, type ButtonProps } from "@chakra-ui/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FiMessageSquare } from "react-icons/fi";
import { rememberPageEntityName } from "./pageEntityNames";
import { useAssistantEntry } from "./useAssistantEntry";

type Props = { entityId: string; entityName: string | null | undefined } & Pick<ButtonProps, "colorScheme">;

export const AskAssistantButton = ({ entityId, entityName, colorScheme }: Props) => {
  const { t } = useTranslation();
  const open = useAssistantEntry({ onPage: true });

  useEffect(() => {
    if (entityName) rememberPageEntityName(entityId, entityName);
  }, [entityId, entityName]);

  if (!open) return null;

  return (
    <Button leftIcon={<FiMessageSquare />} variant="outline" colorScheme={colorScheme} size="sm" onClick={open}>
      {t("Ask the assistant")}
    </Button>
  );
};
